const IDENTITY_TYPE = {
    FREELANCE: 'FREELANCE',
    CLIENT: 'CLIENT',
};

export function connectedAsFreelance(userInfo) {
    if (!userInfo) {
        return false;
    }

    if (userInfo.currentIdentityType === IDENTITY_TYPE.FREELANCE) {
        return true;
    }

    // old header, still used somewhere?
    const identities = userInfo.identities || [];
    if (identities.length === 0 && userInfo.profileId) {
        return true;
    }

    return identities.findIndex((identity) => identity.selected && identity.identityType === IDENTITY_TYPE.FREELANCE) !== -1;
}

export function connectedAsCustomer(userInfo) {
    if (!userInfo) {
        return false;
    }

    if (userInfo.currentIdentityType === IDENTITY_TYPE.CLIENT) {
        return true;
    }

    // old header, still used somewhere?
    const identities = userInfo.identities || [];
    if (identities.length === 0 && userInfo.profileId) {
        return false;
    }

    return identities.findIndex((identity) => identity.selected && identity.identityType === IDENTITY_TYPE.CLIENT) !== -1;
}
